import * as _ from 'lodash';
import { ComponentMeta, IComponentMeta, IPaletteMeta } from './component.meta';

/**
 *  组件库
 *  注册组件
 *  根据组件库key，获取组件定义
 *  获取该组件库所有组件的wrapper
 *
 *  组件库是不可修改对象  所以
 *
 *  componentRepository没有destroy方法  无法被销毁，也不应该被销毁。
 */
export class ComponentRepository {
  private _componentMetaMap: Map<string, ComponentMeta> = new Map<string, ComponentMeta>();

  constructor(private _id: string, private _name: string) {

  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  register(compMeta: IComponentMeta) {
    if (compMeta) {
      _.set(compMeta, 'componentOption.graphic.graphicPath', this._id + '$' + compMeta.id);
      this._componentMetaMap.set(compMeta.id, new ComponentMeta(compMeta));
    }
  }

  batchRegister(compMetaArray: Array<IComponentMeta>) {
    if (_.isArray(compMetaArray)) {
      compMetaArray.forEach((value) => {
        this.register(value);
      });
    }
  }

  /**
   * 指定组件元数据是否存在
   * @param id
   */
  has(id: string): boolean {
    return this._componentMetaMap.has(id);
  }

  getComponents(convert: Function): Array<IPaletteMeta> {
    return Array.from(this._componentMetaMap.values(), (v) => {
      return convert(v);
    });
  }

  get paletteConfig() {
    return {
      key: this._id,
      name: this._name,
      children: _.compact(Array.from(this._componentMetaMap.values()).map(value => value.paletteMeta)),
    };
  }

  getComponentMeta(id: string): ComponentMeta {
    return this._componentMetaMap.get(id);
  }

}
